import CustomsDeclareList from "./CustomsDeclareList";

export default CustomsDeclareList;
